import React from 'react'
import {Form, Button,Card} from 'react-bootstrap'
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {Icon} from 'antd'

import NavLink from 'react-bootstrap/NavLink';

class Login extends React.Component{
  

    render(){
        return (
          
            <div style={{textAlign:"left", fontSize:18}}>
              
              <center>
              <Card bg="outline-dark" text="dark"style={{width: "20rem",height: "5 rem"}}>
                <Card.Title>If you want to Login</Card.Title>
                <br></br>
                <Form>
  <p><pre>Sign in using   <Icon type="google" onClick={()=> {this.props.googleLogin()}} /></pre></p>
  
</Form>

</Card>
</center><br></br>
            </div>
            
        )
    }
}
   
export default Login;